import React from "react";
import "../assets/style.css"
import { useAuth0 } from "../react-auth0-spa";

const Hero = () => {

  const { isAuthenticated } = useAuth0();

return (
  <div className="text-center hero my-5">
    <img className="hero-image" src="https://secureservercdn.net/160.153.138.71/62a.79d.myftpupload.com/wp-content/uploads/2020/04/Bevl-Cloud.png" alt="Bevl Cloud" width="120" />
    <p></p>
    <h1 className="mb-4">Welcome to Bevl Cloud</h1>

    <p className="lead">

    {!isAuthenticated && (
      <div>
      Bevl Cloud is a tool we developed to give our clients access to information; such as invoices, quotes and more. Log in to access your data.
      </div>
    )}
    {isAuthenticated && (
      <div>
      Hi, {global.userData.name}! You're logged into Bevl Cloud. Use the menu at the top of the page to access your information.
      </div>
    )}


    </p>
    <p className="sub">
    {!isAuthenticated && (
      <div>
      Alternatively you can request access by contacting our office. Feel free to give us a call or drop an email.
      </div>
    )}
    </p>


  </div>
)


};

export default Hero;
